import React, {useEffect, useState} from "react";
import LoopIcon from "@mui/icons-material/Loop";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {Tooltip} from "@mui/material";
import {useTranslation} from "i18nano";
import {StatusUpdateAnswer} from "../types/UpdatePartyObject";

interface StatusComponentProps {
    status: StatusUpdateAnswer;
    elseComponent?: React.ReactNode;
}

const StatusComponent = ({status, elseComponent = null}: StatusComponentProps) => {
    const [internalStatus, setInternalStatus] = useState(false);
    const t = useTranslation();

    useEffect(() => {
        let timer: ReturnType<typeof setTimeout>;
        if (status === StatusUpdateAnswer.UPDATED) {
            timer = setTimeout(() => {
                setInternalStatus(true)
            }, 3000)
        } else {
            setInternalStatus(false)
        }

        return () => {
            clearTimeout(timer);
        }
    }, [status])

    if (status === StatusUpdateAnswer.UPDATING) {
        return <Tooltip title={t("Saving")} arrow><LoopIcon color="primary" className={"rotateIcon"}/></Tooltip>
    } else if (status === StatusUpdateAnswer.UPDATED && !internalStatus) {
        return <Tooltip title={t("Saved")} arrow><CheckCircleOutlineIcon color="success"/></Tooltip>
    } else if (status === StatusUpdateAnswer.ERROR && !internalStatus) {
        return <Tooltip title={t("Error")} arrow><ErrorOutlineIcon color={"error"}/></Tooltip>
    } else {
        return elseComponent
    }
}

export default StatusComponent;